export default __webpack_public_path__ + "static/media/fsk-14-fix01.1a3c57ce.jpg";